import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'BrightspeedTheme',
  code: 'Brightspeed',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#FFFFFF',
    footerBackground: '#fa783c',
    footerText: '#fff',
    footerBorder: 'transparent',
    progressBar: '#ffc800',
  },
  logoSize: {
    width: '195px',
    height: '48px',
  },
  baseColors: {
    link: '#ffc800',
    cta: '#ffc800',
    hover: '#e6b400',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const BrightspeedTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
